export default "__VITE_ASSET__D$x08g6Q__"